import { Provider } from '@angular/core';

import { ScheduleRepositoryImpl } from '@app/data/repositories/mot/schedule/schedule.repository';
import { SCHEDULE_REPOSITORY } from '@app/domain/repositories/mot/schedule.repository.contract';

export const scheduleRepositoryProvider: Provider = {
  provide: SCHEDULE_REPOSITORY,
  useClass: ScheduleRepositoryImpl
};
